export enum InsightsTitles {
  TRENDING_TOPICS = 'Trending topics',
  LANGUAGE_DISTRIBUTION = 'Language Distribution in Calls',
  AVERAGE_SATISFACTION = 'Average CSAT Score',
}

export enum AverageCSATScoreTitles {
  OVERALL_SATISFACTION = 'Overall Satisfaction',
  RESOLUTION_RATE = 'Resolution Rate',
}
